const Strategy = () => import( /* webpackChunkName: "Strategy" */ "@/views/strategy/Strategy");
const StrategyList = () => import( /* webpackChunkName: "Strategy List" */ "@/views/strategy/StrategyList");
const StrategyNew = () => import( /* webpackChunkName: "Strategy New" */ "@/views/strategy/StrategyNew");
const StrategyDetails = () => import( /* webpackChunkName: "Strategy Details" */ "@/views/strategy/StrategyDetails");
const StrategyLikes = () => import( /* webpackChunkName: "Strategy Likes" */ "@/views/strategy/StrategyLikes");
const strategyRoutes = [{
  path: "strategy",
  name: "Strategy",
  redirect: {
    name: "Strategy List"
  },
  component: Strategy,
  children: [{
      path: "list",
      name: "Strategy List",
      component: StrategyList
    },
    {
      path: "new",
      name: "Strategy New",
      component: StrategyNew
    },
    {
      path: "edit/:id",
      name: "Strategy Edit",
      component: StrategyNew,
      props: true
    },
    {
      path: "likes/:id",
      name: "Strategy Likes",
      component: StrategyLikes,
      props: true
    },
    {
      path: "details/:id",
      name: "Strategy Details",
      component: StrategyDetails,
      props: true,
      beforeEnter: (to, from, next) => {
        if (to.params.id) {
          next();
        } else {
          next({
            name: from.name
          });
        }
      }
    }
  ]
}];

export default strategyRoutes;
